export enum UserType {
  SystemAdmin = 'systemAdmin',
  CustomerAdmin = 'customerAdmin',
}
